import React, { useEffect, useRef, useState } from 'react';
import '@/scss/pc/test.scss';

function test(): JSX.Element {
    const ref = useRef<any>();
    const [showLeft, setShowLeft] = useState(false);
    const [showRight, setShowRight] = useState(true);
    const [origin_data] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9]);
    const [start_pos, setStartPos] = useState(0);
    const batch_size = 4;
    const handleShow = () => {
        if (ref.current) {
            const { scrollLeft, scrollWidth, clientWidth } = ref.current;
            const maxScrollLeft = scrollWidth - clientWidth;
            setShowLeft(scrollLeft > 0);
            setShowRight(scrollLeft < maxScrollLeft);
        }
    };
    const scrollContentList = (direction) => {
        if (ref.current) {
            if (direction === 'left') {
                $(ref.current).animate({ scrollLeft: ref.current.scrollLeft - 550 });
            }
            if (direction === 'right') {
                $(ref.current).animate({ scrollLeft: ref.current.scrollLeft + 550 });
            }
        }
    };
    const changeBatch = () => {
        const _start_pos = start_pos + batch_size;
        if (_start_pos >= origin_data.length) {
            setStartPos(0);
            return;
        }
        setStartPos(_start_pos);
    };
    useEffect(() => {
        if (ref.current) {
            $(ref.current).on('scroll', handleShow);
            handleShow();
        }
    }, [ref]);
    return (
        <div className="test-container">
            <div className="container">
                {showLeft ? (
                    <button className="scroll-button" onClick={() => scrollContentList('left')}>
                        Left Icon
                    </button>
                ) : (
                    <button className="scroll-button" />
                )}
                <div className="content-list" ref={ref}>
                    {/* Assuming there are 11 list items */}
                    {Array.from({ length: 11 }).map((_, i) => {
                        return <div className="content111">{`Content ${i + 1}`}</div>;
                    })}
                </div>
                {showRight ? (
                    <button className="scroll-button" onClick={() => scrollContentList('right')}>
                        Right Icon
                    </button>
                ) : (
                    <button className="scroll-button" />
                )}
            </div>
            <div className="batch">
                <ul>
                    {[...origin_data].slice(start_pos, start_pos + batch_size).map((item) => (
                        <li>{item}</li>
                    ))}
                </ul>
                <button onClick={changeBatch}>换一批</button>
            </div>
        </div>
    );
}

export default test;
